import RequestModal from './RequestModal.view';

export default RequestModal;
